module.exports = __webpack_public_path__ + "static/media/grandprize.da84f62a.jpg";